module.exports = __webpack_public_path__ + "static/media/payabli_icon.845b9c01.svg";